// extracted by mini-css-extract-plugin
module.exports = {"regular-text":"HomePage_regular-text__23JxS","form-input":"HomePage_form-input__3HXTu","container":"HomePage_container__1sdME"};